import Backbone from "backbone";
import $ from "jquery";
import MutationObserver from "../../polyfills/web.naive-mutationobserver.js";
import ProductSummaryTrimHeightButtonsTemplate from "./ProductSummaryTrimHeightButtons.mustache"

export default Backbone.View.extend({

  maxHeight: 400,

  initialize: function () {
    this.$target = this.$(".js-productSummaryTrimHeight-target");
    var target = this.$target.get(0);
    if (this.$target.length > 0) {
      if (target.querySelector("script") != null) {
        new MutationObserver((records, observer) => {
          if (target.offsetHeight > 400) {
            observer.disconnect();
            this.render();
          }
        }).observe(target, {
          childList: true,
          subtree: true,
          attributes: true,
        });
      }
    }

  },

        events: {
            "click .js-summaryExpandBtn": "expandContent",
            "click .js-summaryCollapseBtn": "collapseContent",
        },

        collapseContent: function () {

            this.$expandButton.show();
            this.$collapseButton.hide();
            this.$target.css("max-height", this.maxHeight);

        },

        expandContent: function () {


          this.$expandButton.hide();
          this.$collapseButton.show();
            if (!this.currentHeight) {
                this.currentHeight = this.$target[0].scrollHeight;
            }
            this.$target.css("max-height", (this.currentHeight * 2));

        },

        render: function () {

            this.$el.append(ProductSummaryTrimHeightButtonsTemplate.render());
            this.$expandButton = this.$(".js-summaryExpandBtn");
            this.$collapseButton = this.$(".js-summaryCollapseBtn");
            this.$target.css("max-height", this.maxHeight);
            return this;

        }

    });
